<script>
export default {
  fetch({ redirect }) {
    return redirect('/');
  },
  fetchOnServer: false,
};
</script>
